import { j as a } from "./jsx-runtime-B6kdoens.js";
import { forwardRef as n } from "react";
function f(r) {
  return n(r);
}
const i = (r, t) => {
  const o = f(
    (e, s) => /* @__PURE__ */ a.jsx(t, { ...e, ref: s })
  );
  return o.displayName = r, o;
};
export {
  i as c,
  f
};
//# sourceMappingURL=create-component-CBAeEoQ6.js.map
